

export class DomesticSalesFilterRequest{
    endCustomerId?:number;
    productName?: string
    unitName?: string
 unitId?:number
    
    constructor( endCustomerId?:number, productName?: string, unitName?: string,unitId?:number ){
        this.endCustomerId = endCustomerId;
        this.productName = productName
        this.unitName = unitName
this.unitId=unitId
    }
}
